import * as Yup from 'yup';
import { TaskPriority, TaskType } from '../../../domain/types';

export const taskValidationSchema = Yup.object({
  type: Yup.string()
    .oneOf(Object.values(TaskType))
    .required('Il campo è obbligatorio'),
  title: Yup.string().required('Il campo è obbligatorio'),
  description: Yup.string(),
  priority: Yup.string()
    .oneOf(Object.keys(TaskPriority))
    .required('Il campo è obbligatorio'),
});
